<template>
    <div>
        <div v-html="html"></div>
    </div>
</template>
<script>
export default {
    name:'payLoading',
    data(){
        return{
            html:''
        }
    },
    mounted(){
        this.html=localStorage.getItem('html')
    }
}
</script>